import Titles from '../../../components/Titles/Titles'
import Button from '../../../components/Buttons/Button'
import { IMediaAndContent } from '../../../interfaces/MediaAndContent';
import MediaAndContentMapper from '../../../components/Mappers/MediaAndContentMapper';
import { Link } from 'react-router-dom';
import useIsMobile from '../../../hooks/useIsMobile';
import { responsivePadding, responsivePaddingLeft } from "../../../layouts/ResponsiveContainer"

interface IFeaturedActivities {
    activities: IMediaAndContent[] | null;
}

const FeaturedActivities = ({ activities }: IFeaturedActivities) => {
    const isMobile = useIsMobile(904);

    return (
        <section className="flex flex-col w-full mt-[3.25rem] md:mt-13">
            <div className={`flex justify-between items-center mb-10 ${responsivePadding}`}>
                <Titles
                    title={!isMobile ? 'Actividades destacadas' : 'Actividades'}
                    withBgPattern={false}
                    color='text-brand-green-20'
                />
                <Link to='/monitor/actividades'>
                    <Button
                        label='Ver más'
                        showIconLeft={false}
                        showIconRight={false}
                        variant='primary'
                    />
                </Link>
            </div>
            <div className={`${responsivePaddingLeft} overflow-x-auto md:overflow-visible scrollbar-hide`}>
                <MediaAndContentMapper
                    data={activities}
                    viewType='mini'
                    variant='brand'
                    disableScroll={!isMobile ? false : true}
                    spacer={true}
                />
            </div>
        </section >
    )
}

export default FeaturedActivities